export class Weeks {
  id: any;
  name: string;
  start_date: string;
  end_date: string;
  lunch_cost: number;
  bus_cost?: number;
}

export class WeekDetail {
  id: number;
  name: string;
  start_date: string;
  end_date: string;
}

export class Excursion {
  id: any;
  name: string;
  description: string;
  hol_week_id: number;
  hol_class_id: number;
}

export class AddExcursion {
  name: string;
  place: string;
  description: string;
  hol_week_id: number;
  hol_class_id: number;
}

export class ExcursionDetail {
  id: any;
  name: string;
  place: string;
  description: string;
  hol_week_id: number;
  hol_class_id: number;
  hol_course_id: number;
}

export class Questionnarie {
  id?: number;
  order: number;
  question: string;
  answer: object[];
  status: boolean;
}

export class UpsertQuestionnarie {
  id?: number;
  order: number;
  question: string;
  answer: string[];
  status: boolean;
}

export class DiscoundConfig {
  id: number;
  key: string;
  value: string;
  condition: string;
}


// WEBPACK FOOTER //
// ./src/holiday/models/Settings.ts